export const getDefaultImageData = () => ({
    isListingImage: false,
    imageId: null,
    rotationDegrees: null,
    imageUrl: null,
    firstEmpty: false,
    isUploading: false
});
